import { FC, useContext, useMemo, useState } from 'react';
import { Spin } from 'antd';
import { SpotTypeEnum } from '@/views/spotevaluation/pages/index/ts-config';
import { typeEnum } from '@/views/surround/pages/index/ts-config';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import { useMethods } from '@lhb/hook';
import { isArray, isNotEmpty } from '@lhb/func';
import { getStorage, removeStorage } from '@lhb/cache';
import { AI_AUTH_KEY, FromType, SPOT_DETAIL_AI_RESULT_CACHE_DATA } from '@/common/components/business/AIAreaDetailModule/ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
import AreaOverview from './components/AreaOverview';
import BussinessStore from './components/BussinessStore';
import Surround from './components/Surround';
import StoreList from 'src/common/components/business/YouthMap/AreaDetailDrawer/components/FirstScreenRight/components/StoreList';
import SimilarBusinessCircle from '@/common/components/business/YouthMap/AreaDetailDrawer/components/FirstScreenRight/components/SimilarBusinessCircle';
import AI from '@/common/components/business/AIAreaDetailModule';
import { competitorsCoefficient, competitorsCoefficientShare } from '@/common/api/spotevaluation';
import dayjs from 'dayjs';
import UserInfoContext from '@/layout/context';

/**
 * @Description 选址地图详情-右侧内容区域
 */
const FirstScreenRight: FC<{
  detail: any;
  overViewData: any;
  setStoreChecked: (value: boolean) => void;
  setSurroundingChecked: (value: boolean) => void;
  curDetail: any;
  setCurDetail: (value: any) => void;
  setStoreOptions: (value: any[]) => void;
  setSurroundingOptions: (value: any[]) => void;
  tenantId: string;
  drawerData: any;
  mapIns: any;
  rangeMarkerRef: any;
  setIsOpenHeatMap: (value: boolean) => void;
  configSwitch: any;
  enableBrandCompetitionDistinguish: boolean;
  shareParams: any;
  isSemirModel: boolean;
  mainHeight: string|number;
  spotEvaluationConfig: any;
  isStartAnalyseOfAI?: boolean;
  setIsStartAnalyseOfAI?: any;
  agentTenant?: any;
}> = ({
  detail,
  overViewData,
  setStoreChecked,
  setSurroundingChecked,
  curDetail,
  setCurDetail,
  setStoreOptions,
  setSurroundingOptions,
  tenantId,
  drawerData,
  mapIns,
  rangeMarkerRef,
  setIsOpenHeatMap,
  configSwitch,
  enableBrandCompetitionDistinguish,
  shareParams,
  isSemirModel = false,
  mainHeight,
  spotEvaluationConfig,
  isStartAnalyseOfAI,
  setIsStartAnalyseOfAI,
  agentTenant,
}) => {
  const [isAIFailed, setIsAIFailed] = useState<boolean>(false);
  const { tenantInfo } = useContext(UserInfoContext); // 租户信息

  const { tenantCheckInfo } = useTenantCheckInfo({ immediate: !tenantId }); // 租户信息;
  // 奥乐齐：竞争系数数据，场景说明：打开详情后，点击《立即查看》之后只请求一次，数据缓存在父组件中,状态提升到这里是为了防止BussinessStore组件未来会有 ? <Com> : <></> 这种场景导致state被初始化
  const [coefficientVal, setCoefficientVal] = useState<any>({
    standardCompetitionCoefficient: 0, // 标准竞争系数 默认值 0
    secondaryCompetitionCoefficient: 0, // 次级竞争系数
    isLoading: false, // 是否在加载中
    hasLoadedData: false, // 是否请求过过数据
  });
  // 地址
  const address = useMemo(() => {
    const {
      centerAddress,
      provinceName,
      cityName,
      districtName
    } = detail || {};
    let str = '';
    if (provinceName && provinceName !== cityName) {
      str += provinceName;
    }
    if (cityName) str += cityName;
    if (districtName) str += districtName;
    if (centerAddress) str += centerAddress;
    return str;
  }, [detail]);
  /** 是否是ALQ */
  const isALQ = useMemo(() => {
    return tenantId ? shareParams?.isALQ : !!tenantCheckInfo?.isALQ;
  }, [tenantId, shareParams, tenantCheckInfo?.isALQ]);

  // 生成中的商圈没有数据，不展示该模块
  const showOverview = useMemo(() => {
    let isShow = false;// 是否展示
    // 判断评分是否都不为空
    overViewData?.scores?.forEach((item) => {
      if (item && item.score) isShow = true;
    });
    return isShow;
  }, [overViewData]);
  // 处理传入本品牌门店列表的参数
  const storeListParams = useMemo(() => {
    const { type, poiSearchType, lng, lat, radius, points, poiSearchMinute, } = drawerData || {};
    // 街边店
    if (type === SpotTypeEnum.Street) {
      if (poiSearchType === typeEnum.radius) { // 查询的是半径时
        return {
          polygonQuery: 1, // 查询类型是：圆
          lng,
          lat,
          radius,
          poiSearchType,
        };
      }
      return {
        polygonQuery: 2, // 查询的是围栏(步行/汽车/驾车)
        points,
        lng: +lng || null,
        lat: +lat || null,
        poiSearchType,
        // 点位测评围栏范围单位（1-距离，2-分钟）
        poiSearchRangeUnit: isNotEmpty(poiSearchMinute) ? 2 : 1
      };
    }
    return null;
  }, [drawerData]);

  // 缓存的AI分析点位测评的数据
  const targetCacheAIResult = useMemo(() => {
    const cacheData = getStorage(SPOT_DETAIL_AI_RESULT_CACHE_DATA);
    const { date, data } = cacheData || {};
    // 是否缓存过AI分析的数据
    if (date) {
      // 是否是同一天
      if (dayjs().format('YYYY-MM-DD') === date) {
        if (isArray(data) && data.length) {
          return data.find((item: any) => item.id === drawerData?.id);
        }
      }
      // 清空缓存
      removeStorage(SPOT_DETAIL_AI_RESULT_CACHE_DATA);
    }
    return null;
  }, [isStartAnalyseOfAI]);
    // 显示AI模块的时机
  const showAIModule = useMemo(() => {
    // 分享时不展示
    if (shareParams) return false;
    // 该租户是否配置了AI智能体
    if (!agentTenant?.agentId) return false;
    // 点击了AI分析 || 已经有缓存的数据了
    return isStartAnalyseOfAI || !!targetCacheAIResult || isAIFailed;
  }, [shareParams, isStartAnalyseOfAI, agentTenant?.agentId, targetCacheAIResult, isAIFailed]);

  const AIInputStr = useMemo(() => {
    const { type, poiSearchType, modelConfigId, lng, lat, radius, poiSearchMinute, poiSearchDistance, modelClusterId } = drawerData as any || {};
    if (type === SpotTypeEnum.Street) { // 街边店
      return `业务场景：场景B-点位测评-街边店，入参：${JSON.stringify({
        type, // 街边店
        modelConfigId,
        lng,
        lat,
        radius,
        tenantId: tenantInfo?.id,
        poiSearchType,
        poiSearchMinute,
        poiSearchDistance,
        points: detail.points,
        authKey: AI_AUTH_KEY,
      })}`;
    }
    if (type === SpotTypeEnum.Mall) { // 商场店
      return `业务场景：场景A-点位测评商场，入参：${JSON.stringify({
        id: modelClusterId,
        modelConfigId,
        tenantId: tenantInfo?.id,
        authKey: AI_AUTH_KEY,
      })}`;
    }
    // 默认值：
    return `业务场景：场景B-点位测评-街边店，入参：${JSON.stringify({
      type: 1, // 街边店
      modelConfigId,
      lng,
      lat,
      radius: 500,
      tenantId: tenantInfo?.id,
      poiSearchType: 1,
      points: detail.points,
      authKey: AI_AUTH_KEY,
    })}`;
  }, [drawerData, detail, tenantInfo]);
  const methods = useMethods({
    // 奥乐齐竞争系数数据
    handleALQDCompetitionCoefficients(params: any) {
      setCoefficientVal((state) => ({ ...state, isLoading: true }));
      const targetFetch = shareParams ? competitorsCoefficientShare : competitorsCoefficient;
      targetFetch(params).then((res: any) => {
        const { standardCompetitionCoefficient, secondaryCompetitionCoefficient } = res || {};
        setCoefficientVal({
          standardCompetitionCoefficient,
          secondaryCompetitionCoefficient,
          isLoading: false, // 是否在加载中
          hasLoadedData: true, // 是否请求过过数据
        });
      });
    },
  });

  return (
    <div className={styles.firstScreenRightCon} style={{ height: (mainHeight) }}>
      {/* AI模块 */}
      {
        showAIModule && <AI
          input={AIInputStr}
          id={drawerData?.id}
          extraParams={{
            ...(drawerData?.type === SpotTypeEnum.Mall ? { areaName: detail.areaName } : {}),
            ...(drawerData?.type === SpotTypeEnum.Street ? { address } : {})
          }}
          agentTenant={agentTenant}
          isStartAnalyseOfAI={isStartAnalyseOfAI}
          setIsStartAnalyseOfAI={setIsStartAnalyseOfAI}
          targetCacheAIResult={targetCacheAIResult}
          type={FromType.spotDetail}
          // className={'mb-6'}
          isAIFailed={isAIFailed}
          setIsAIFailed={setIsAIFailed}
        />
      }

      {/* 商圈的概览信息 */}
      {
        showOverview
          ? <AreaOverview
            detail={detail}
            overViewData={overViewData}
            mapIns={mapIns}
            rangeMarkerRef={rangeMarkerRef}
            tenantId={tenantId}
            setIsOpenHeatMap={setIsOpenHeatMap}
            configSwitch={configSwitch}
            shareParams={shareParams}
            isSemirModel={isSemirModel}
            spotEvaluationConfig={spotEvaluationConfig}
          />
          : <div className={styles.scoreModule}>
            <Spin />
          </div>
      }
      {/* 相似商圈（仅商场店展示） */}
      {drawerData?.type === SpotTypeEnum.Mall && (
        <SimilarBusinessCircle
          modelClusterId={drawerData.modelClusterId}
          modelConfigId={drawerData.modelConfigId}
          configSwitch={configSwitch}
          detailLevel={0}
          isShare={!!(shareParams && Object.keys(shareParams)?.length > 0)}
          tenantId={drawerData.tenantId}
          userId={drawerData.userId}
        />
      )}
      {/* 本品牌门店 */}
      <div className='mt-16'>
        <StoreList
          detail={ { id: drawerData?.modelClusterId } }
          streetPointParams={storeListParams}
          noDataPermission
          viewDetail={true} // 可以查看详情
          isNeedShareAPI={drawerData?.tenantId || drawerData?.userId}
          tenantId={drawerData?.tenantId}
          employeeId={drawerData?.userId}
          isShare={shareParams && Object.keys(shareParams)?.length > 0}
        />
      </div>
      {/* 经营门店 */}
      <BussinessStore
        detail={detail}
        setStoreChecked={setStoreChecked}
        curDetail={curDetail}
        setCurDetail={setCurDetail}
        setStoreOptions={setStoreOptions}
        tenantId={tenantId}
        drawerData={drawerData}
        spotEvaluationConfig={spotEvaluationConfig}
        isALQ={isALQ}
        coefficientVal={coefficientVal}
        handleALQDCompetitionCoefficients={methods.handleALQDCompetitionCoefficients}
        enableBrandCompetitionDistinguish={enableBrandCompetitionDistinguish}
      />
      {/* 周边配套 */}
      <Surround
        detail={detail}
        setSurroundingChecked={setSurroundingChecked}
        setSurroundingOptions={setSurroundingOptions}
        curDetail={curDetail}
        setCurDetail={setCurDetail}
        tenantId={tenantId}
        drawerData={drawerData}
        shareParams={shareParams}
        isALQ={isALQ}
      />
    </div>
  );
};

export default FirstScreenRight;
